/**
 * 日期工具函数
 */
import { data } from '../shared.js';

export function localDateStr(d) {
    if (d === undefined) d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
}

export function getToday() { return localDateStr(new Date()); }

export function getSelectedDate() {
    return data.selectedDate || getToday();
}

export function setSelectedDate(dateStr, showToast, saveData) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        if (showToast) showToast('日期格式不正确', 'error');
        return false;
    }
    data.selectedDate = dateStr;
    if (saveData) saveData();
    return true;
}
